{
  "version": "v4.3.0",
  "name": "CreateLiquidPool",
  "bytecodeTemplate": "0101030002001fb41700{1}{2}{3}{4}{5}110d{0}0105170116007a{1}{9}a3{2}{10}a316001600{6}{7}{8}110e160101251818",
  "fieldsSig": {
    "names": [
      "factory",
      "token0",
      "token1",
      "configIndex",
      "sqrtPriceX96",
      "rewardToken",
      "tickLower",
      "tickUpper",
      "liquidity",
      "amount0",
      "amount1"
    ],
    "types": [
      "PoolFactory",
      "ByteVec",
      "ByteVec",
      "U256",
      "U256",
      "ByteVec",
      "I256",
      "I256",
      "U256",
      "U256",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}